module.exports = __webpack_public_path__ + "img/visa.1ef55e88.png";